import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { approveRecognition } from 'api/recognitions.service';
import { useToast } from 'hooks/ui';
import { useApplicationStore } from 'store/application';
import { setDraftRecognition } from 'store/recognition';
import { recognitionKeys } from './queryKeys';

export const useRecognitionApproveQuery = () => {
  const toast = useToast();
  const queryClient = useQueryClient();
  const { setLoading, removeLoading } = useApplicationStore();

  const { isPending, mutate } = useMutation({
    mutationFn: (id: string) => {
      setLoading();

      return approveRecognition(id);
    },
    onSuccess: (recognition) => {
      toast.success('Recognition has been approved successfully');
      setDraftRecognition(recognition);
    },
    onError: (error: AxiosError) => {
      toast.error(error.message);
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: recognitionKeys.all });
      removeLoading();
    },
  });

  return { isLoading: isPending, mutate };
};
